import React, { useRef, useEffect } from 'react'

const url = "https://cdn.synthetix.com/synthetix.min.js?applicationkey=09eb27883c6b2441a1265146337f0a63&consumerkey=d55c9df3224767eca9631494cb1d7bab";

const Synthetix = () => {

  const container = useRef(null);
  const element = "synjs";

  // reason for dynamically adding script tag is react renders but isn't loading and executing script tags when included in component definition. 
  useEffect(() => 
  {
      // guard against double execution. When react strict mode is used the component will render twice despite useEfect is setup to render once.
      if(document.getElementById(element) === null)
      {
          let script = document.createElement("script");
          script.id = element;
          script.type = "text/javascript";
          script.src = url;
          script.async = true;
          container.current.appendChild(script);  
      }

  }, []);

  return (
    <div ref={container}></div>  
  )
}

export default Synthetix;